import React, { useState } from 'react';
import './Ammounts.css';

const left = [
  { display: '1 BAN', value: 0.1 },
  { display: '1 LEU', value: 1 },
  { display: '5 LEI', value: 5 },
  { display: '10 LEI', value: 10 },
  { display: '20 LEI', value: 20 },
  { display: '50 LEI', value: 50 },
  { display: '75 LEI', value: 75 },
  { display: '100 LEI', value: 100 },
  { display: '250 LEI', value: 250 },
  { display: '500 LEI', value: 500 },
  { display: '700 LEI', value: 700 },
  { display: '900 LEI', value: 900 },
];
const right = [
  { display: '1.000 LEI', value: 1000 },
  { display: '2.500 LEI', value: 2500 },
  { display: '5.000 LEI', value: 5000 },
  { display: '7.500 LEI', value: 7500 },
  { display: '10.000 LEI', value: 10000 },
  { display: '12.500 LEI', value: 12500 },
  { display: '15.000 LEI', value: 15000 },
  { display: '20.000 LEI', value: 20000 },
  { display: '25.000 LEI', value: 25000 },
  { display: '50.000 LEI', value: 50000 },
  { display: '75.000 LEI', value: 75000 },
  { display: '100.000 LEI ', value: 100000 },
];




function Ammounts({ resetSignal, onRemove, onRestore, removedLeft = [], removedRight = [] }) {
  const [animateIn, setAnimateIn] = useState(false);
  const [showRestoreLeft, setShowRestoreLeft] = useState([]); // values for which restore button is shown
  const [showRestoreRight, setShowRestoreRight] = useState([]);
  const [restoringLeft, setRestoringLeft] = useState([]); // values currently animating in
  const [restoringRight, setRestoringRight] = useState([]);

  React.useEffect(() => {
    setAnimateIn(false);
    setShowRestoreLeft([]);
    setShowRestoreRight([]);
    setRestoringLeft([]);
    setRestoringRight([]);
    const timer = setTimeout(() => setAnimateIn(true), 50);
    return () => clearTimeout(timer);
  }, [resetSignal]);

  React.useEffect(() => {
    setAnimateIn(false);
    setShowRestoreLeft([]);
    setShowRestoreRight([]);
    setRestoringLeft([]);
    setRestoringRight([]);
    const timer = setTimeout(() => setAnimateIn(true), 50);
    return () => clearTimeout(timer);
  }, []);

  // When removedLeft/removedRight changes, after animation, show restore button for new removals
  React.useEffect(() => {
    // Find new removals
    const newRemoved = removedLeft.filter(v => !showRestoreLeft.includes(v));
    if (newRemoved.length > 0) {
      const timeout = setTimeout(() => {
        setShowRestoreLeft(prev => [...prev, ...newRemoved]);
      }, 400); // match animation duration
      return () => clearTimeout(timeout);
    }
  }, [removedLeft, showRestoreLeft]);

  React.useEffect(() => {
    const newRemoved = removedRight.filter(v => !showRestoreRight.includes(v));
    if (newRemoved.length > 0) {
      const timeout = setTimeout(() => {
        setShowRestoreRight(prev => [...prev, ...newRemoved]);
      }, 400);
      return () => clearTimeout(timeout);
    }
  }, [removedRight, showRestoreRight]);

  const handleRemove = (side, value) => {
    if (onRemove) onRemove(side, value);
  };

  const handleRestore = (side, value) => {
    // Start slide-in animation
    if (side === 'left') {
      setRestoringLeft(prev => [...prev, value]);
      setShowRestoreLeft(prev => prev.filter(v => v !== value));
    } else {
      setRestoringRight(prev => [...prev, value]);
      setShowRestoreRight(prev => prev.filter(v => v !== value));
    }
    // After animation, call onRestore and remove from restoring
    setTimeout(() => {
      if (onRestore) onRestore(side, value);
      if (side === 'left') setRestoringLeft(prev => prev.filter(v => v !== value));
      else setRestoringRight(prev => prev.filter(v => v !== value));
    }, 400); // match animation duration
  };

  return (
    <div className="bp-values">
      <div className="bp-values-left">
        {left.map((item) => {
          const isRemoved = removedLeft.includes(item.value);
          const showRestore = showRestoreLeft.includes(item.value);
          const isRestoring = restoringLeft.includes(item.value);
          if (isRemoved && showRestore) {
            return (
              <button
                className={"bp-restore-btn bp-restore-btn-low"}
                key={item.display}
                aria-label={`Restore ${item.display}`}
                onClick={() => handleRestore('left', item.value)}
              />
            );
          } else if (isRestoring) {
            return (
              <div
                className="bp-value bp-value-low bp-slide-in-left"
                key={item.display}
                data-value={item.value}
              // not clickable while animating in
              >
                {item.display}
              </div>
            );
          } else if (isRemoved) {
            return (
              <div
                className="bp-value bp-value-low bp-slide-left"
                key={item.display}
                data-value={item.value}
              // not clickable while animating out
              >
                {item.display}
              </div>
            );
          } else {
            return (
              <div
                className={`bp-value bp-value-low${!animateIn ? ' bp-slide-left' : ''}`}
                key={item.display}
                data-value={item.value}
                onClick={() => handleRemove('left', item.value)}
              >
                {item.display}
              </div>
            );
          }
        })}
      </div>
      <div className="bp-values-right">
        {right.map((item) => {
          const isRemoved = removedRight.includes(item.value);
          const showRestore = showRestoreRight.includes(item.value);
          const isRestoring = restoringRight.includes(item.value);
          if (isRemoved && showRestore) {
            return (
              <button
                className={"bp-restore-btn bp-restore-btn-high"}
                key={item.display}
                aria-label={`Restore ${item.display}`}
                onClick={() => handleRestore('right', item.value)}
              />
            );
          } else if (isRestoring) {
            return (
              <div
                className="bp-value bp-value-high bp-slide-in-right"
                key={item.display}
                data-value={item.value}
              // not clickable while animating in
              >
                {item.display}
              </div>
            );
          } else if (isRemoved) {
            return (
              <div
                className="bp-value bp-value-high bp-slide-right"
                key={item.display}
                data-value={item.value}
              // not clickable while animating out
              >
                {item.display}
              </div>
            );
          } else {
            return (
              <div
                className={`bp-value bp-value-high${!animateIn ? ' bp-slide-right' : ''}`}
                key={item.display}
                data-value={item.value}
                onClick={() => handleRemove('right', item.value)}
              >
                {item.display}
              </div>
            );
          }
        })}
      </div>
    </div>
  );
}

export default Ammounts;
